
import { defineComponent, inject, onMounted, ref } from "vue";
import { Chart, registerables } from "chart.js";
import { useStore } from "vuex";
import dayjs from "dayjs";
import "v-calendar/dist/style.css";
import { Menu, MenuButton, MenuItem, MenuItems } from "@headlessui/vue";
import { useRoute, useRouter } from "vue-router";
// import { ChevronDownIcon } from "@heroicons/vue/solid";
// import rawData from "./c4810a75-a492-4aa8-a0dc-c2162c8c3621.json";
Chart.register(...registerables);

export default defineComponent({
  name: "HomeView",
  components: {
    Menu,
    MenuButton,
    MenuItem,
    MenuItems,
    // ChevronDownIcon,
  },
  setup() {
    const axios: any = inject("$axios");
    let store = useStore();
    let route = useRoute();
    let router = useRouter();
    let date = ref(dayjs().format('YYYY-MM-DD'));
    let data = ref()
    let masks = ref({
      modelValue: 'YYYY-MM-DD',
    });

    onMounted(() => {
      if (route.params.date) {
        date.value = dayjs(Array.isArray(route.params.date) ? route.params.date[0] : route.params.date).format('YYYY-MM-DD');
      } else {
        date.value = dayjs().format("YYYY-MM-DD"); // ถ้าไม่มีให้ใช้วันนี้
        // อัปเดต URL ให้มี ?date= วันนี้
        router.replace({
          name: route.name || undefined,
          params: { date: date.value }
        });
      }
      getData()
    })

    const getData = async () => {
      return axios
        .post(process.env.VUE_APP_API_ENDPOINT + "/admin/api/v1/dashboard/summary", {
          operatorId: store.state.selectedOperator.operatorId,
          date: dayjs(date.value.toString()).format('YYYY-MM-DD'),
          size: 10
        })
        .then(async (response: any) => {
          data.value = response.data.result;
          data.value.provider_rank = data.value.provider_rank.sort((a: any, b: any) => (b.value - a.value))
          setTimeout(async () => {
            await getData()
          }, 60 * 1000);
        })
        .catch((err: any) => {
          console.log(err);
          return [];
        });
    };

    const fetchUser = async (username: string) => {
      const payload: any = {
        operatorId: store.state.selectedOperator.operatorId,
        filter: {
          username: username,
        },
        page: 0,
        pageSize: 5,
        sortBy: [["createdAt", -1]],
      };

      const url = `${process.env.VUE_APP_API_ENDPOINT}/admin/api/v1/operator-admin/cms/user/list-pagination`;
      const { data } = await axios.post(url, payload)

      router.push({
        name: "Wallet Info",
        params: { id: data.result.data[0].id },
      });
    }

    const removeFromSuspect = async (payload: any, i: number) => {
      await axios.post(process.env.VUE_APP_API_ENDPOINT + "/admin/api/v1/dashboard/suspect/delete", {
        ...payload,
        username: payload.name,
        userId: payload.id,
        operatorId: store.state.selectedOperator.operatorId,
        date: dayjs(date.value.toString()).format('YYYY-MM-DD'),
      }).then((res: any) => {
        data.value.suspects.splice(i, 1)
      })
    }

    return {
      removeFromSuspect,
      date,
      data,
      masks,
      getData,
      fetchUser
    };
  },
});
